import { Link } from 'react-router-dom';

const footerCategories = [
  {
    title: '热门频道',
    links: [
      { label: '网红黑料', href: '/category/wanghong-heidiao' },
      { label: '明星塌房', href: '/category/mingxing-tafang' },
      { label: '直播吃瓜', href: '/category/zhibo-chigua' },
      { label: '娱乐八卦', href: '/category/yule-bagua' },
    ],
  },
  {
    title: '内容专区',
    links: [
      { label: '黑料视频', href: '/category/shipin-heiliao' },
      { label: '每日热点', href: '/category/meiri-redian' },
      { label: '深夜访谈', href: '/category/shenye-fangtan' },
      { label: '吃瓜百科', href: '/category/chigua-baike' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌故事', href: '/about' },
      { label: '联系我们', href: '/about#contact' },
      { label: '用户协议', href: '/about' },
      { label: '隐私政策', href: '/about' },
    ],
  },
  {
    title: '友情链接',
    links: [
      { label: '娱乐头条', href: '#', },
      { label: '八卦日报', href: '#', },
      { label: '明星动态', href: '#', },
      { label: '影视资讯', href: '#', },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-accent-500 text-background-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:w-[320px] flex-shrink-0">
            <Link to="/" className="inline-flex items-center gap-2 mb-4">
              <span className="text-2xl font-bold font-heading text-background-50">
                17吃瓜
              </span>
              <span className="px-2 py-0.5 bg-background-50/20 text-background-50 text-xs rounded-full font-label">
                官网
              </span>
            </Link>

            <div className="relative mb-5">
              <input
                type="email"
                placeholder="输入邮箱订阅每日爆料"
                className="w-full px-4 py-3 pr-12 bg-background-50/15 border border-background-50/25 rounded-lg text-background-50 placeholder:text-background-50/50 text-sm font-label outline-none focus:border-background-50/50 transition-colors"
              />
              <button className="absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-full hover:bg-primary-400 transition-colors duration-200 cursor-pointer">
                <i className="ri-notification-3-line text-sm"></i>
              </button>
            </div>

            <p className="text-background-50/80 text-2xl md:text-3xl font-heading leading-snug">
              每日新鲜大瓜
              <br />
              准时送达你的邮箱
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 flex-1">
            {footerCategories.map((col) => (
              <div key={col.title}>
                <h4 className="text-background-50/60 text-xs font-label uppercase tracking-wider mb-4">
                  {col.title}
                </h4>
                <ul className="flex flex-col gap-2.5">
                  {col.links.map((link) => (
                    <li key={link.label}>
                      {link.href.startsWith('/') ? (
                        <Link
                          to={link.href}
                          className="text-background-50/80 text-sm font-label hover:text-background-50 transition-colors duration-200"
                        >
                          {link.label}
                        </Link>
                      ) : (
                        <a
                          href={link.href}
                          className="text-background-50/80 text-sm font-label hover:text-background-50 transition-colors duration-200"
                          rel="nofollow"
                        >
                          {link.label}
                        </a>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background-50/50 text-xs font-label">
            &copy; 2026 17吃瓜网. 保留所有权利.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="w-9 h-9 flex items-center justify-center border border-background-50/25 rounded-lg text-background-50/70 hover:text-background-50 hover:border-background-50/50 transition-colors duration-200" rel="nofollow" aria-label="微博">
              <i className="ri-weibo-line text-sm"></i>
            </a>
            <a href="#" className="w-9 h-9 flex items-center justify-center border border-background-50/25 rounded-lg text-background-50/70 hover:text-background-50 hover:border-background-50/50 transition-colors duration-200" rel="nofollow" aria-label="微信">
              <i className="ri-wechat-line text-sm"></i>
            </a>
            <a href="#" className="w-9 h-9 flex items-center justify-center border border-background-50/25 rounded-lg text-background-50/70 hover:text-background-50 hover:border-background-50/50 transition-colors duration-200" rel="nofollow" aria-label="抖音">
              <i className="ri-tiktok-line text-sm"></i>
            </a>
            <a href="#" className="w-9 h-9 flex items-center justify-center border border-background-50/25 rounded-lg text-background-50/70 hover:text-background-50 hover:border-background-50/50 transition-colors duration-200" rel="nofollow" aria-label="B站">
              <i className="ri-bilibili-line text-sm"></i>
            </a>
          </div>
          <Link
            to="/about"
            className="text-background-50/50 text-xs font-label hover:text-background-50/80 transition-colors duration-200"
          >
            隐私政策
          </Link>
        </div>
      </div>
    </footer>
  );
}